import React from 'react';
import styles from '../OrderList.module.css';

function HowManyOrderWillShow({ setPageLimit }) {
    return (
        <div className={styles['shopify-page-limit']}>
            <select
                name="orderLimit"
                className={styles['shopify-select']}
                onChange={(e) => setPageLimit(Number(e.target.value))}
                defaultValue={10}
            >
                <option value={10}>10 per page</option>
                <option value={20}>20 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
            </select>
        </div>
    );
}

export default HowManyOrderWillShow;
